const visaOwnerType = {
  investor: 1,
  employee: 2
}

const visaStatus = [
  {id: 1, name: 'Active', color: 'green', icon: 'tick'},
  {id: 2, name: 'Expired', color: 'yellow', icon: 'time'},
  {id: 3, name: 'Cancelled', color: 'red', icon: 'cross-big'}
]

const contractType = [
  {id: 1, name: 'Limited'},
  {id: 2, name: 'Unlimited'}
]

export {visaOwnerType, visaStatus, contractType}



// WEBPACK FOOTER //
// ./src/constants/companyVisas.js